import { useMe } from '../lib/auth.tsx';
import { DashboardPage } from './DashboardPage.tsx';
import { PlatformOverviewPage } from './platform/OverviewPage.tsx';

/** 홈: 플랫폼 관리자(지원 열람 모드 아님)는 플랫폼 개요, 그 외는 테넌트 대시보드 (CR-020) */
export function HomePage() {
  const me = useMe();
  return me.data?.role === 'platform_admin' && !me.data.support ? <PlatformOverviewPage /> : <DashboardPage />;
}
